import { PageLocatorMap } from '../types/PageLocatorMap';

export const applicantUnemploymentDetailsPage = {
  alert: {
    error: 'applicant-unemployment-details-page.form.alert.error',
  },
  footer: {
    root: 'applicant-unemployment-details-page.footer.root',
  },
  form: {
    grossAnnualIncomeInput:
      'applicant-unemployment-details-page.form.gross-annual-income-input',
    grossAnnualIncomeInputError:
      'applicant-unemployment-details-page.form.gross-annual-income-input-error',
    h1: 'applicant-unemployment-details-page.form.h1',
    h2: 'applicant-unemployment-details-page.form.h2',
    root: 'applicant-unemployment-details-page.form.root',
    submitButton: 'applicant-unemployment-details-page.form.submit-button',
  },
} as const satisfies PageLocatorMap;
